import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, BookOpen, Calendar, Heart, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { createPageUrl } from "../../utils";
import { useLanguage } from "../../i18n";

const icons = [MapPin, BookOpen, Calendar, Heart];

export default function QuickLinks() {
  const { t } = useLanguage();
  const quickLinks = t("home.quickLinks", []);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-sm font-semibold tracking-[0.24em] uppercase text-[#C9A227] mb-3">
            {t("home.startHere")}
          </p>
          <h2 className="font-serif-elegant text-3xl sm:text-4xl font-bold text-[#722F37] mb-4">
            {t("home.quickLinksTitle")}
          </h2>
          <p className="font-sans-clean text-gray-600 max-w-2xl mx-auto">
            {t("home.quickLinksBody")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickLinks.map((link, index) => {
            const Icon = icons[index % icons.length];

            return (
              <motion.div
                key={link.page}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <Link
                  to={createPageUrl(link.page)}
                  className="group block h-full p-6 bg-[#f7f1e8] rounded-3xl border border-[#C9A227]/10 hover:shadow-xl hover:border-[#C9A227]/30 transition-all duration-300"
                >
                  <div className="w-14 h-14 rounded-2xl burgundy-gradient flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="font-serif-elegant text-xl font-semibold text-gray-900 mb-3">
                    {link.title}
                  </h3>
                  <p className="font-sans-clean text-gray-600 text-sm mb-4">
                    {link.description}
                  </p>
                  <span className="inline-flex items-center gap-2 text-sm font-medium text-[#722F37]">
                    {t("home.openPage")}
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
